
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon }
})
export default class InlineTxtEdit extends Vue {
  @Prop({ required: true }) value!: string;
  @Prop({ default: "" }) placeholder!: string;
  @Prop({ default: "span" }) component!: string;
  @Prop({ default: false }) active!: boolean;

  editing = false;
  editValue = "";
  hover = false;
  enterPressed = false;

  @Watch("active")
  onActiveChange(newVal: boolean) {
    if (newVal) {
      this.activateEdit();
    }
  }

  activateEdit() {
    this.$emit("editing", true);
    this.editing = true;
    this.editValue = this.value;
    this.$nextTick(() => {
      (this.$refs.input as HTMLInputElement).focus();
    });
  }

  onEnter() {
    this.enterPressed = true;
    this.save();
  }

  onBlur() {
    if (!this.enterPressed) {
      this.save();
    }
    this.enterPressed = false;
  }

  save() {
    if (!this.editValue.trim()) {
      this.cancel();
      return;
    }
    this.$emit("update", this.editValue);
    this.$emit("editing", false);
    this.editing = false;
  }

  cancel() {
    this.editing = false;
  }
}
